<template>
  <div class="flex flex-col device-name-wrap"  :class="align" >
    <div class="horizontal items-center" @click="onDeviceNameEdit">
      <span class="device-name-only">{{ legal ? deviceName : 'Illage Device' }}</span>
      <van-image v-if="showEdit" style="margin-left:4px" :src="require('@/assets/icons/v2/icon_edit_flavor.png')" width="20" height="20"/>
    </div>

    <span class="device-id">{{ deviceId.toUpperCase() }}</span>
    <PopupSingleEdit v-model="showModifyDeviceName"
        title="Rename My Product"
        placeholder="Enter name"
        :max-length="30"
        :init-content="deviceName"
        @onConfirm="onConfirm"
        @onCancel="onCancel"/>
  </div>
</template>

<script>
import log from "@/util/log";
import PopupSingleEdit from "@/components/common/PopupSingleEdit.vue";
import user from "@/api/user";

export default {
  name: "DeviceName",
  props: {
    showEdit: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    },
    deviceName: {
      type: String,
      default: ""
    },
    deviceId: {
      type: [String,Number],
      default: ""
    },
    deviceType: {
      type: String,
      default: "1" //0 bt 1 nfc 后台接口的定义
    },
    align: {
      type: String,
      default: "items-center justify-center"
    },
    legal: {
      type:Boolean,
      default:true
    }
  },
  components: { PopupSingleEdit },
  data() {
    return {
      showModifyDeviceName: false
    };
  },
  methods: {
    onDeviceNameEdit() {
      if (this.deviceId === "0989236299263892963") {
        return;
      }
      if (!this.showEdit) {
        return;
      }
      log("设备名字点击更改");
      this.showModifyDeviceName = true;
    },
    async onConfirm(content) {
      try {
        const resp = await user.updateProductName({
          deviceMac: this.deviceId,
          deviceName: content,
          deviceType: this.deviceType
        }, true);
        this.$toast({
          message: resp.message
        });
        this.$emit("onUpdateDeviceName", content);
        this.showModifyDeviceName = false;
      } catch (e) {
        console.log(e)
        this.$toast({
          message: e
        });
      }
    },
    onCancel() {
      this.showModifyDeviceName = false;
    },
    onDeviceNameChange(e) {
      this.$emit("onDeviceNameChange", e);
    }
  }
};
</script>


<style scoped lang="less">
.device-name-wrap {
  font-size: 14px;
  display: flex;
  min-height: 14px;
}

.device-id {
  font-size: 12px;
  color: #A4A6A5;
  line-height: 12px;
  margin-top:2px;
}

.device-name-only {
  font-size:16px;
  position: relative;
  min-height: 18px;

}

.device-name {
  position: relative;
  font-size:16px;

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    right: 0px;
    transform: translateY(-50%);
    width: 20px; /* 设置图标宽度 */
    height: 20px; /* 设置图标高度 */
    background-image: url('../../assets/icons/v2/icon_edit_flavor.png'); /* 设置图标图片的路径 */
    background-size: cover; /* 让图标自适应大小 */
  }
}
</style>